import { render, staticRenderFns } from "./ViewCalendarItemPage.vue?vue&type=template&id=009c994c&scoped=true&"
import script from "./ViewCalendarItemPage.vue?vue&type=script&lang=js&"
export * from "./ViewCalendarItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewCalendarItemPage.vue?vue&type=style&index=0&id=009c994c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009c994c",
  null
  
)

export default component.exports